import _ from 'underscore';
import $ from 'jquery';

export default class OfferCampaignRecipientAttachmentsDialog {
  constructor($scope, $rootScope, OfferCampaignService) {
    function get_dialog_data() {
      OfferCampaignService.get_attachments(window.offer_campaign.id).success(function(data) {
        $scope.attachments = data.attachments;
      });
    }

    $scope.$on('show_select_attachments', function(event, data) {
      $scope.select_all = false;
      $scope.recipients = data.recipients;
      if ($scope.recipients.length == 1) {
        var attachments = _.pluck($scope.recipients[0].campaign_attachments, 'id');
        _.each($scope.attachments, function(a) {
          a.checked = _.contains(attachments, a.id);
        });
      } else {
        _.each($scope.attachments, function(a) {
          a.checked = false;
        });
      }
      window.openFancyboxDialog('div#offer_campaign_recipient_attachments_dialog');
    });

    $scope.check_attachments = function() {
      _.each($scope.attachments, function(a) {
        a.checked = $scope.select_all;
      });
    };

    $scope.save = function() {
      var attachments = _.where($scope.attachments, {
        checked: true
      });
      $scope.saving = true;
      OfferCampaignService.save_attachments(_.pluck($scope.recipients, 'id'), _.pluck(attachments, 'id')).success(function(data) {
        if (data.success) {
          $rootScope.$broadcast('load_offer_campaign_recipients');
          $scope.saving = false;
          $.fancybox.close();
        }
      });
    };

    $scope.init = function() {
      get_dialog_data();
    };

    $scope.init();
  }
}

OfferCampaignRecipientAttachmentsDialog.$inject = ['$scope', '$rootScope', 'OfferCampaignService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/offer-campaign-recipient-attachments-dialog.ctrl.js